import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { Box, xcss } from '@atlaskit/primitives';
import TextRenderType from '../text';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var IconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left'
});
var textWrapperStyles = xcss({
  marginLeft: 'space.100',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
export var ICON_TYPE_TEST_ID = 'link-datasource-render-type--icon';
export var ICON_TYPE_TEXT_TEST_ID = "".concat(ICON_TYPE_TEST_ID, "-text");

/**
 * @deprecated: To be cleaned up and replaced with new-icon after
 * `platform-datasources-enable-two-way-sync-priority` rollout.
 */
var IconRenderType = function IconRenderType(_ref) {
  var label = _ref.label,
    text = _ref.text,
    source = _ref.source,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? ICON_TYPE_TEST_ID : _ref$testId;
  return /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: source,
    alt: label,
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: {
      minWidth: '20px',
      maxWidth: '20px'
    } // having just width: '20px' shrinks it when table width is reduced
  }), text && /*#__PURE__*/React.createElement(Box, {
    xcss: textWrapperStyles
  }, /*#__PURE__*/React.createElement(TextRenderType, {
    testId: ICON_TYPE_TEXT_TEST_ID,
    text: text
  })));
};
export default IconRenderType;